export default function () {
  return function (input) {
    var re = /{(.*)}/;
    var output = input.match(re);
    return output[1];
  }
}


// WEBPACK FOOTER //
// ./src/js/eshop/Filters/brackets.js